import React from "react";
import isArray from "lodash/isArray";
import Image, { StaticImageData } from "next/image";

export type IFactoidWithIcon = {
    image: StaticImageData;
    title: string;
    value: string | string[];
    unitName: string;
};

const FactoidWithIcon = ({ image, title, value, unitName }: IFactoidWithIcon) => {
    function renderValue() {
        // Convert to an array of <span>{value}</span><br/> values
        if (isArray(value)) {
            return (value as string[])
                .map((valueString, index) => [<span key={valueString + index}>{valueString}</span>, <br key={valueString + index + "br"} />])
                .flat()
                .slice(0, -1);
        }

        return value;
    }

    return (
        <div className="FactoidWithIcon flex items-center gap-2">
            <div className="FactoidWithIcon-icon h-[40px] w-[40px]">
                <Image
                    src={image}
                    alt=""
                    style={{
                        maxWidth: "100%",
                        height: "auto"
                    }}
                />
            </div>
            <div className="FactoidWithIcon-fact">
                <h4 className="FactoidWithIcon-title tracking-aption text-caption text-accent-secondary-light">{title}</h4>
                <p className="FactoidWithIcon-value tetx-subheadline1 font-bold tracking-subheadline1 text-info-light">{renderValue()}</p>
                <p className="FactoidWithIcon-unitName text-caption font-bold tracking-caption text-info-light">{unitName}</p>
            </div>
        </div>
    );
};

export default FactoidWithIcon;
